import { EducationLevelEnum } from '../interfaces/EducationModels';

export const EDUCATION_LEVEL_LABEL_KEYS: Record<EducationLevelEnum, string> = {
  [EducationLevelEnum.Unknown]: 'work_preferences.education_level_unknown',
  [EducationLevelEnum.Primary]: 'work_preferences.education_level_primary',
  [EducationLevelEnum.MiddleSchool]: 'work_preferences.education_level_middle_school',
  [EducationLevelEnum.V_Mbo]: 'work_preferences.education_level_v_mbo',
  [EducationLevelEnum.SecondaryAndPostSecondary]: 'work_preferences.education_level_secondary_post_secondary',
  [EducationLevelEnum.Mbo_General]: 'work_preferences.education_level_mbo_general',
  [EducationLevelEnum.Mbo_1]: 'work_preferences.education_level_mbo_1',
  [EducationLevelEnum.Mbo_2]: 'work_preferences.education_level_mbo_2',
  [EducationLevelEnum.Mbo_3]: 'work_preferences.education_level_mbo_3',
  [EducationLevelEnum.Mbo_4]: 'work_preferences.education_level_mbo_4',
  [EducationLevelEnum.Bachelor]: 'work_preferences.education_level_bachelor',
  [EducationLevelEnum.HboMaster]: 'work_preferences.education_level_hbo_master',
  [EducationLevelEnum.WoBachelor]: 'work_preferences.education_level_wo_bachelor',
  [EducationLevelEnum.Master]: 'work_preferences.education_level_master',
  [EducationLevelEnum.WoPhd]: 'work_preferences.education_level_wo_phd',
};

export const SELECTABLE_EDUCATION_LEVELS: EducationLevelEnum[] = [
  EducationLevelEnum.Primary,
  EducationLevelEnum.MiddleSchool,
  EducationLevelEnum.V_Mbo,
  EducationLevelEnum.SecondaryAndPostSecondary,
  EducationLevelEnum.Mbo_General,
  EducationLevelEnum.Mbo_1,
  EducationLevelEnum.Mbo_2,
  EducationLevelEnum.Mbo_3,
  EducationLevelEnum.Mbo_4,
  EducationLevelEnum.Bachelor,
  EducationLevelEnum.HboMaster,
  EducationLevelEnum.WoBachelor,
  EducationLevelEnum.Master,
  EducationLevelEnum.WoPhd,
];
